<a class="skip-link" href="#maincontent">Skip to main content</a>
<span class="loader" [hidden]="loaded"></span>
<div class="{{showBrandValue}}" [style.display]="_hideSignonUI ? 'none' : null">
<main id="maincontent" tabindex="-1">
<crs-core [class.ui-body-disabled]="!loaded"></crs-core>
</main></div>
<div class="pageLoader" #overlay>
    <div class="blackout">
        <span class="loader"></span>
    </div>
</div>
